const TERMS_OF_USE_AND_SALE = 'https://legal.fabfitfun.com/#terms-of-use';
const MEMBERSHIP_TERMS = 'https://legal.fabfitfun.com/#box-membership-terms';
const PRIVACY_POLICY = 'https://legal.fabfitfun.com/#privacy-policy';
const FABFITFUN_SUPPORT =
  'https://support.fabfitfun.com/en/articles/44-how-can-i-contact-customer-care';
const MORE_DETAILS = 'https://support.fabfitfun.com/en/articles/33-what-s-your-cancellation-policy';
const LEARN_MORE = 'https://support.fabfitfun.com/en/articles/63-how-much-does-shipping-cost';
const BILLING = 'https://support.fabfitfun.com/en/articles/4-billing-shipping-schedule';
const SUPPORT = 'https://support.fabfitfun.com';
const CANCEL_POLICY =
  'https://support.fabfitfun.com/en/articles/33-what-s-your-cancellation-policy';

export {
  TERMS_OF_USE_AND_SALE,
  MEMBERSHIP_TERMS,
  PRIVACY_POLICY,
  FABFITFUN_SUPPORT,
  MORE_DETAILS,
  LEARN_MORE,
  BILLING,
  SUPPORT,
  CANCEL_POLICY,
};
